import { serviceOptions } from '@services/api'
import { normalizeStatsDateRangeQuery } from '@services/statsQueryUtils'

export interface GetExamStatsQuery {
  siteId?: number
  examId?: number
  startDate: string
  endDate: string
}

export interface StatsExamCountDTO {
  total: number
}

export interface StatsExamTypeCodeBreakdownDTO {
  examTypeLabel: string
  examId: number
  examCode: string
  examLabel: string
  total: number
}

const getAxiosClient = () => {
  if (!serviceOptions.axios) {
    throw new Error('Axios client is not configured')
  }

  return serviceOptions.axios
}

export const fetchExamStatsCount = async (
  params: GetExamStatsQuery,
): Promise<StatsExamCountDTO> => {
  const normalizedParams = normalizeStatsDateRangeQuery(params)

  const response = await getAxiosClient().get<StatsExamCountDTO>(
    '/stats/exams/count',
    { params: normalizedParams },
  )

  return response.data
}

export const fetchExamTypeCodeBreakdown = async (
  params: GetExamStatsQuery,
): Promise<StatsExamTypeCodeBreakdownDTO[]> => {
  const normalizedParams = normalizeStatsDateRangeQuery(params)

  const response = await getAxiosClient().get<StatsExamTypeCodeBreakdownDTO[]>(
    '/stats/exams/type-code/breakdown',
    { params: normalizedParams },
  )

  return response.data
}
